import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import PasskeyManager from '../components/Auth/PasskeyManager';

const SecuritySettings = () => {
  return (
    <Container fluid className="security-settings-page">
      <Row className="mb-4">
        <Col>
          <h1 className="page-title">Configuración de Seguridad</h1>
          <p className="text-muted">
            Gestiona tus métodos de autenticación y preferencias de seguridad
          </p>
        </Col>
      </Row>

      <Row>
        <Col lg="10" xl="8">
          <PasskeyManager />
        </Col>
      </Row>

      <style>{`
        .security-settings-page {
          padding: 2rem 0;
        }

        .security-settings-page .page-title {
          font-size: 2rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }
      `}</style>
    </Container>
  );
};

export default SecuritySettings;
